import { useState } from 'react';
import { IHistorySearch } from '../../interfaces/components/index.interface';

//not confirm which keys that each item in data array contain yet
const HistorySearch: React.FC<IHistorySearch> = ({ visible, onClick }) => {
  const [historySearchData, setHistorySearchData] = useState(() => {
    const FAKE_DATA: string = localStorage.getItem('searchHistory') || '';
    const history = FAKE_DATA ? JSON.parse(FAKE_DATA) : [];
    return history;
  });

  return (
    <div
      className={`${
        visible ? 'flex' : 'hidden'
      } flex-col min-w-full bg-white z-50 flex-1`}
    >
      {historySearchData.map((item: any, index: number) => (
        <div
          key={index}
          className="w-full border-b py-2 px-4 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick && onClick(item);
          }}
        >
          {item}
        </div>
      ))}
      {historySearchData.length > 0 && (
        <p
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            localStorage.removeItem('searchHistory');
            setHistorySearchData([]);
          }}
          className="cursor-pointer opacity-50 w-full text-center my-2"
        >
          Xóa tất cả
        </p>
      )}
    </div>
  );
};

export default HistorySearch;
